import { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import ToastContainer from 'Components/toaster/ToastContainer';

const withToaster = (WrappedComponent) => (props) => {
  const [list, setList] = useState([]);
  const [map, setMap] = useState({});

  const create = ({ duration, message }) => {
    const id = uuidv4();
    const timeoutId = setTimeout(() => {
      dismiss(id);
    }, duration);
    return {
      duration,
      id,
      message,
      timeoutId,
    };
  };

  const dispatch = ({ duration = 5000, message }) => {
    const toast = create({ duration, message });
    setList((list) => [...list, toast.id]);
    setMap((map) => ({ ...map, [toast.id]: toast }));
  };

  const dismiss = (id) => {
    setList((list) => list.filter((_id) => _id !== id));
    setMap((map) => {
      const { [id]: deleted, ...rest } = map;
      clearTimeout(deleted.timeoutId);
      return rest;
    });
  };

  const dismissAll = () => {
    list.forEach((id) => {
      const { timeoutId } = map[id];
      clearTimeout(timeoutId);
    });
    setList([]);
    setMap({});
  };

  useEffect(() => dismissAll(), []);

  return (
    <>
      <WrappedComponent
        {...props}
        dismissToast={dismiss}
        dismissAllToasts={dismissAll}
        dispatchToast={dispatch}
      />
      <ToastContainer dismiss={dismiss} list={list} map={map} />
    </>
  );
};

export default withToaster;
